import * as z from "zod";
import { processorHistoryItemSchema } from "./get-processor-history";

const recentlyProcessedItemSchema = processorHistoryItemSchema.extend({
  processorName: z.string(),
});

export const getRecentlyProcessedItems = {
  name: "getRecentlyProcessedItems" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    returnsCenterId: z.string().optional(),
    teamIds: z.array(z.string()).optional(),
  }),
  output: z.object({
    /** Newest first. */
    items: z.array(recentlyProcessedItemSchema),
    truncated: z.boolean(),
  }),
};

export type RecentlyProcessedItem = z.infer<typeof recentlyProcessedItemSchema>;
